import { render, staticRenderFns } from "./BmvButton.vue?vue&type=template&id=04f6ec03&scoped=true"
import script from "./BmvButton.vue?vue&type=script&lang=js"
export * from "./BmvButton.vue?vue&type=script&lang=js"
import style0 from "./BmvButton.vue?vue&type=style&index=0&id=04f6ec03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f6ec03",
  null
  
)

export default component.exports